var map = {
	"./ProseccoNabucco.jpg": "bb94",
	"./VBELCIRCOMALABARISTAMACABEO.jpg": "1fc2",
	"./VBHONOROVERAVERDEJO.jpg": "f3ff",
	"./VBSENORIODEVILLARRICAALBARINOJUANITO.jpg": "c66f6",
	"./VBTRASIEGOSELECCIONBLANCA.jpg": "b9d8",
	"./VRCARTA.jpg": "4b5d",
	"./VRELCIRCOPAYASOROSADO.jpg": "3ef3",
	"./VTALTOTINTONEBBIOLO.jpg": "2503",
	"./VTBOSQUEDEMATASNOSCRIANZA.jpg": "d9d0",
	"./VTCUATRONINAS.jpg": "d4ea",
	"./VTFORZACONCIERTOENOLOGICO.jpg": "a870",
	"./VTMONTEPULCIANODABRUZZOSTORICO.jpg": "0784",
	"./VTNEROPAVONIAVOLATERRESICILIANEEPICO.jpg": "651f",
	"./VTOBERTURACONCIERTOCABERNETMERLOT.jpg": "db82",
	"./VTPRIMITIVOPUGLIAPAVONISECOLO.jpg": "b5d3",
	"./VinoBlancoOladia.jpg": "7c79",
	"./VinoBlancoVerdades.jpg": "3ae7",
	"./VinoTintoAltotintoAltaReserva.jpg": "e7ba",
	"./VinoTintoAltotintoSelección.jpg": "7552",
	"./VinoTintoAnecdota6meses.jpg": "545f",
	"./VinoTintoBailarinaMerlot.jpg": "3cb3",
	"./VinoTintoCastillodeSantiago.jpg": "3b53",
	"./VinoTintoCaymusSpecialSelection.jpg": "6f68",
	"./VinoTintoCircoArlequinSyrah.jpg": "0f04",
	"./VinoTintoCircoVolatineroTempranillo.jpg": "939d",
	"./VinoTintoClio.jpg": "b393",
	"./VinoTintoContorsionistaCabernet.jpg": "a653",
	"./VinoTintoElegido.jpg": "23f5",
	"./VinoTintoFT34Malbec.jpg": "4c9c",
	"./VinoTintoFlorentino.jpg": "0be3",
	"./VinoTintoForzudoCrianza.jpg": "d08d",
	"./VinoTintoGrapho.jpg": "8843",
	"./VinoTintoGuanameMalbec.jpg": "6038",
	"./VinoTintoJuanGilPlata.jpg": "9964",
	"./VinoTintoMonteabellon14meses.jpg": "78eb",
	"./VinoTintoMonteabellon5meses.jpg": "1d7b",
	"./VinoTintoOladiaCarmenere.jpg": "7137",
	"./VinoTintoPagosdeQuintanaCrianza.jpg": "68df",
	"./VinoTintoPagosdeQuintanaReserva.jpg": "fcb8",
	"./VinoTintoPagosdeQuintanaRoble.jpg": "2ae3",
	"./VinoTintoPauta.jpg": "ff6d",
	"./VinoTintoRiojaVegaCrianza.jpg": "9520",
	"./VinoTintoRiojaVegaReserva.jpg": "6c28",
	"./VinoTintoRiojaVegaTempranillo.jpg": "4776",
	"./VinoTintoTono8.jpg": "c35e",
	"./VinoTintoVerdades.jpg": "23a0",
	"./la_redonda.png": "e802",
	"./laredonda.jpg": "81de",
	"./montevina.jpg": "7886",
	"./montevina.png": "2762"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c915";